'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesPause: {
            type: String,
            default: undefined,
            kComposite: 'messages.pause'
        },
        messagesPlay: {
            type: String,
            default: undefined,
            kComposite: 'messages.play'
        },
        messagesMute: {
            type: String,
            default: undefined,
            kComposite: 'messages.mute'
        },
        messagesUnmute: {
            type: String,
            default: undefined,
            kComposite: 'messages.unmute'
        },
        messagesQuality: {
            type: String,
            default: undefined,
            kComposite: 'messages.quality'
        },
        messagesFullscreen: {
            type: String,
            default: undefined,
            kComposite: 'messages.fullscreen'
        }
    }
};